import { OrderStatus } from '../../graphql/order/models/get-orders.models';

export const getOrderStatusTranslation = (orderStatus: string) => {
  for (const key in OrderStatus) {
    if (orderStatus === OrderStatus[key as keyof typeof OrderStatus]) {
      return `order.status.${key}`;
    }
  }
};
